export default __webpack_public_path__ + "static/media/imgActivity8-7.c0d6b6aa.png";